import React, { useState, useEffect, useContext, useMemo } from "react";
import informesContext from "../../context/informesContext/informesContext";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import controlContext from "../../context/control/controlContext";
import { ALERTSProcedimientosProgramados } from "../../utils/states";
import normalizeText from "../../utils/normalizeText";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import activoContext from "../../context/activoContex/activoContex";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaDocumentos = ({setGridToShow}) =>{

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango, 
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        filtrar
    } = cContext;

    const uContext = useContext(usuariosContext);
    const {userListView, saveColumnsPreferences} = uContext

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const iContext = useContext(informesContext);
    const {generarInformeExcel} = iContext;

    const acContext = useContext(activoContext);
    const {docsXactivoList,getDocsXActivo} = acContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasDocumentos ?? [], [usuario])

    const [columns, setColumns] = useState([
        {width: 200, property: 'nameDocumento', title: 'Documento', visible: true },
        {width: 200, property: 'codDocumento', title: 'Código Doc.', visible: true },
        {width: 325, property: 'nameActivo', title: 'Activo', visible: true },
        {width: 250, property: 'codActivo', title: 'Cod. Activo', visible: true },
        {width: 200, property: 'fecha', title: 'Vencimiento', visible: true },
        {width: 150, property: 'tipoAlertaString', title: 'Tipo Alerta', visible: true },
        {width: 300, property: 'textAdic', title: 'Texto Adicional', visible: true },
        {width: 200, property: 'alertaAnticipo', title: 'Alerta Anticipo', visible: true },
    ]);
    const [columnsTotals, setColumnsTotals] = useState([
        {width: 200, property: '', title: '', visible: true },
        {width: 150, property: '', title: '', visible: true },
        {width: 250, property: '', title: '', visible: true },
        {width: 100, property: 'codActivo', title: 'Cod. Activo', visible: true },
        {width: 75, property: 'fecha', title: 'Vencimiento', visible: true },
        {width: 75, property: 'tipoAlertaString', title: 'Tipo Alerta', visible: true },
        {width: 125, property: 'textAdic', title: 'Texto Adicional', visible: true },
        {width: 100, property: 'alertaAnticipo', title: 'Alerta Anticipo', visible: true },
    ]);
    const [docsFiltered,setDocsFiltered] = useState(undefined);
    const [filter,setFilter] = useState('');
    const [showFilters,setShowFilter] = useState(false);
    const [showSelectColumns,setShowSelectColumns] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({todos: 1, vencidos: 0, porVencer:0});
    const [selct,setSelec] = useState([])

    const handlerIniciarlizarFiltros = async () => {
        const state = ALERTSProcedimientosProgramados;
        await iniciarFiltros(state, usuario);
    }

    const handleGenerarInforme = async() =>{
        let dataToExcel = []; //Arreglo que contendra tanto el Header del excel como las Filas Hijas de Informacion.
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title); //Arreglo que contiene el nombre de las columnas o header.
        dataToExcel.push(columnsTitle); //Se pushea la primer fila del excel.

        //Por cada OT filtrada se crea un array nuevo, a este se le pushearan las propiedades que hayan sido especificadas en la visualizacion del informe en el frontend.
        
        for(const d of docsFiltered){
            let docModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                (Array.isArray(d[col.property])) ? docModelado.push(d[col.property].length) : (col.property == 'fecha') ? docModelado.push(d[col.property].substring(0,10)) : docModelado.push(d[col.property]);
            }
            if(docModelado.length > 0) dataToExcel.push(docModelado); //Si algun campo coincidio lo pushea a dataToExcel para ser impresa en el .xlsx.
        }
        await generarInformeExcel(dataToExcel, 'Documentos'); //Viaja hacia la funcion del contexto para ser generado el xlsx.
    }

    const handleChangeColumnsVisible = (e, c, i) =>{
        setColumns((prevCols) => prevCols.map((c,index) => index == i ? {...c, visible: e.target.checked} : c))
    }

    const handlerClickFilter = (itm) => {
        setShowFilter(false)
    }

    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    useEffect(() => {
        getDocsXActivo();
        handlerIniciarlizarFiltros();
    }, []);

    useEffect(()=>{
        if(filter != ''){
            const nFilter = normalizeText(filter);
            let docs = docsXactivoList.filter(d => (normalizeText(d.codActivo).includes(nFilter) || normalizeText(d.codDocumento).includes(nFilter) || normalizeText(d.nameActivo).includes(nFilter) || normalizeText(d.nameDocumento).includes(nFilter)));
            setDocsFiltered(docs);
        }else setDocsFiltered(docsXactivoList);
    },[filter]);

    useEffect(()=>{
        if(docsXactivoList != undefined && docsXactivoList != null){
            let docsFiltradosToSet = filtrar(docsXactivoList,filtrosEstado,filtrosRango,'Documentos');
            setDocsFiltered(docsFiltradosToSet);
        };
    },[docsXactivoList,filtrosEstado,filtrosRango]);

    useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0){
            setColumns(prevColumns => prevColumns.map(c => ({...c, visible: columnsPreferences.includes(c.property)})))
        }
    },[columnsPreferences])


    return <div className="grillaInformeDiv">
    <div className="utilitiesDiv">
        <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        <SearchInput filter={filter} buscar={setFilter}/>
        <FilterScreen verFiltro={setShowFilter}/>
        <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
        <button disabled={docsFiltered == undefined || docsFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
    </div>
    {
        (docsFiltered == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (docsFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay documentos cargados</h3> : <Table array={docsFiltered} columns={columns} setColumns={setColumns}/>
    }
    {
        showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"Documentos"}/>
    }
    {showFilters &&
            <div className="addFilterContainer">
                <AddFilter
                    usuarios={userListView} 
                    item={selectedFilter} 
                    cerrar={handlerClickFilter} 
                    filtro={{filtrosRango, filtrosEstado}} 
                    aplicarFiltros={apFiltros} 
                    workspace={activeWorkSpace} 
                    selct={selct}
                    setSelec={setSelec}
                    componentePadre='Documentos'
                />
            </div>
        }
</div>

}

export default GrillaDocumentos;